import { useCallback } from 'react';
import { useChannel } from '@/services/api/cable';
import { useIsAuthenticated } from '@/stores/auth';
import { useNotificationsStore } from '@/stores/notifications';

const LABEL: Record<string, string> = {
  new_inquiry: 'Novo inquérito recebido',
  new_message: 'Nova mensagem recebida',
  order_placed: 'Pedido recebido',
  mention: 'Você foi mencionado',
  new_post: 'Novo post na comunidade',
  payment_confirmed: 'Pagamento confirmado',
};

export const useLiveNotifications = () => {
  const authed = useIsAuthenticated();
  const push = useNotificationsStore((s) => s.push);

  const onMessage = useCallback(
    (m: { type: string }) => {
      push({ type: m.type, message: LABEL[m.type] ?? 'Atualização' });
    },
    [push],
  );

  useChannel(authed ? 'NotificationsChannel' : '', {}, onMessage);
};
